import React from 'react';
import { Filter, TextInput } from 'react-admin';

const PresentsFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Present name" source="name" alwaysOn />
  </Filter>
);

export default PresentsFilter;
